import store from 'app/store/index';
import { ScreenEnum } from 'app/shared/enums';

export const getIsMubiLeasingConfig = () => {
  const firstScreenKey = store.getState().formsConfig.overwrittenFormConfig
    .config?.screens?.[0].key;

  return firstScreenKey && firstScreenKey === ScreenEnum.MubiLeasingShortPath;
};
